import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WindowsClosedIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M12.6969 4C13.9108 4 15.0483 4.59227 15.7444 5.58672L20.0001 11.6663V19.9H4.1001V4H12.6969ZM14.2698 6.61896C13.9105 6.10569 13.3234 5.8 12.6969 5.8H5.9001V11.0499H17.3715L14.2698 6.61896ZM18.2001 12.8499H5.9001V18.1H18.2001V12.8499Z"
      />
    </SvgIcon>
  );
});
